import(/* webpackMode: "eager", webpackExports: ["BlogNavActions"] */ "/vercel/path0/apps/frontend/components/blog/blog-nav-actions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.5.7_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.64.1/node_modules/next/dist/client/app-dir/link.js");
